import React from "react";
import { Link } from "react-router-dom";
import { Coffee } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-[#F2EBE1] mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <Coffee className="h-5 w-5 text-[#C05A46]" strokeWidth={1.5} />
            <span className="font-serif text-2xl">BrewFinder</span>
          </div>
          <p className="text-sm text-[#786B63] leading-relaxed max-w-xs">
            A handcrafted directory for people who care where their coffee comes from. Roasters, cafés, and quiet corners — found by humans, for humans.
          </p>
        </div>
        <div className="text-sm text-[#786B63]">
          <p className="uppercase tracking-wider text-xs mb-3 text-[#2C1E16]">Explore</p>
          <ul className="space-y-2">
            <li><Link to="/directory" className="hover:text-[#C05A46]">The Directory</Link></li>
            <li><Link to="/cities" className="hover:text-[#C05A46]">Browse all cities</Link></li>
            <li><Link to="/lists" className="hover:text-[#C05A46]">Lists & guides</Link></li>
            <li><Link to="/submit" className="hover:text-[#C05A46]">Submit a discovery</Link></li>
          </ul>
        </div>
        <div className="text-sm text-[#786B63]">
          <p className="uppercase tracking-wider text-xs mb-3 text-[#2C1E16]">Brewed with care</p>
          <p className="leading-relaxed">
            Every listing is reviewed by real coffee drinkers. No paid placements, no fluff — just honest signal from the community.
          </p>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 text-xs text-[#786B63] flex justify-between flex-wrap gap-2">
          <span>© {new Date().getFullYear()} BrewFinder</span>
          <div className="flex gap-4">
            <a href="/api/sitemap.xml" target="_blank" rel="noreferrer" className="hover:text-[#C05A46]" data-testid="footer-sitemap-link">Sitemap</a>
            <span>Made for slow mornings.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
